"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var toOption = function toOption(option) {
  return typeof option === 'string' ? {
    text: option,
    value: option
  } : option;
};

var handleChange = function handleChange(onChange) {
  return function (ev) {
    if (onChange) {
      onChange(toOption(ev.target.value).value);
    }
  };
};

var SelectInput = function SelectInput(_a) {
  var id = _a.id,
      onChange = _a.onChange,
      options = _a.options,
      value = _a.value,
      label = _a.label,
      className = _a.className,
      selectClassName = _a.selectClassName,
      subText = _a.subText,
      props = __rest(_a, ["id", "onChange", "options", "value", "label", "className", "selectClassName", "subText"]);

  return react_1.default.createElement("div", {
    className: classnames_1.default('form-group', className)
  }, label && react_1.default.createElement("label", {
    htmlFor: id
  }, label), react_1.default.createElement("select", __assign({
    id: id,
    value: value,
    className: classnames_1.default('form-control', selectClassName),
    onChange: handleChange(onChange)
  }, props), (options || []).map(function (option) {
    return toOption(option);
  }).map(function (_a, i) {
    var value = _a.value,
        text = _a.text;
    return react_1.default.createElement("option", {
      value: value,
      key: i
    }, text);
  })), subText && react_1.default.createElement("small", {
    className: 'form-text text-muted'
  }, subText));
};

exports.default = SelectInput;